import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DocumentDTO } from 'src/app/demo/model/DocumentDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { WebStorage } from '../../../auth/storage/web.storage';
import { DocumentDayDTO } from 'src/app/demo/model/DocumentDayDTO';
import { HttpResponse } from '@angular/common/http';
import { ITEMS_PER_PAGE } from 'src/app/demo/constants/pagination.constants';
import { Buffer } from 'buffer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DatePipe } from '@angular/common';
import { Common } from 'src/app/demo/utils/common';

interface SelectedDoc {
    selectFile: any;
    documentObj: any;
}

@Component({
    selector: 'app-sent-photo',
    templateUrl: './sent-photo.component.html',
    styleUrls: ['./sent-photo.component.scss'],
    providers: [DatePipe],
})
export class SentPhotoComponent {
    sortField: string = '';
    sentDocumentList: DocumentDayDTO[] = [];
    userData: any;
    search: any = {
        page: 0,
        size: 10,
        sort: 'id,desc',
    };
    search2: any = {
        page: 0,
        size: 10,
        sort: 'id,desc',
    };
    pageContext = {
        page: 0,
        previousPage: 0,
        itemsPerPage: 10,
        totalItems: 0,
        sort: 'id,desc',
    };
    unSentDocumentList: DocumentDayDTO[] = [];
    todaysDate: string | null = Common.momentTimeZoneDate(new Date());
    lastDate: string | null = Common.momentTimeZoneDate(new Date());
    selectedDocMap = new Map<number | undefined, SelectedDoc>();
    isLoading: boolean = false;
    isLoading2: boolean = false;
    selectedbatch: string = 'Daily';
    batchList: any = [
        { label: 'Daily', value: 'Daily' },
        { label: 'Monthly', value: 'Monthly' },
        { label: 'Weekly', value: 'Weekly' },
    ];
    monthDate: Date | undefined = new Date();
    selectedDates!: Date[] | undefined;
    firstDay!: any;
    lastDay!: any;

    todaysDate2: string | null = Common.momentTimeZoneDate(new Date());
    lastDate2: string | null = Common.momentTimeZoneDate(new Date());
    selectedbatch2: string = 'Daily';
    batchList2: any = [
        { label: 'Daily', value: 'Daily' },
        { label: 'Monthly', value: 'Monthly' },
        { label: 'Weekly', value: 'Weekly' },
    ];
    monthDate2: Date | undefined = new Date();
    selectedDates2!: Date[] | undefined;
    firstDay2!: any;
    lastDay2!: any;
    isTrue: boolean = true;
    isTrue2: boolean = true;

    constructor(
        private lookupService: LookupService,
        private storage: WebStorage,
        public ref: DynamicDialogRef,
        private datePipe: DatePipe,
        private cdr: ChangeDetectorRef
    ) {
        this.pageContext.itemsPerPage = ITEMS_PER_PAGE;
    }

    ngOnInit() {
        this.userData = this.storage.getUserData();
        this.queryData();
        this.queryData2();
    }

    queryData2() {
        this.isLoading2 = this.isTrue2;
        this.search2.size = this.pageContext.itemsPerPage;
        this.search2.page = this.pageContext.page;
        this.search2.sort = this.pageContext.sort;
        this.search2['schoolId.equals'] = this.userData.schoolId;
        this.search2['docStatus'] = 'A';
        this.search2['date.greaterThanOrEqual'] =
            this.todaysDate2 + 'T00:00:00.000Z';
        this.search2['date.lessThanOrEqual'] = this.lastDate2 + 'T23:59:59.009Z';
        this.search2['docStatus'] = 'I';
        this.lookupService.queryDocumentsByDay(this.search2).subscribe(
            (res: HttpResponse<DocumentDayDTO[]>) => {
                let temp: DocumentDayDTO[] = [];
                this.isLoading2 = false;
                this.unSentDocumentList = res.body ? res.body : temp;
            },
            (error) => {
                this.isLoading2 = false;
                if (error.error.status == 400 || error.error.status == 500) {
                    this.unSentDocumentList = [];
                }
                // Handle the error here, such as showing a message or performing other actions
            }
        );
    }

    queryData() {
        this.isLoading = this.isTrue;
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = this.pageContext.sort;
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['docStatus'] = 'A';
        this.search['date.greaterThanOrEqual'] =
            this.todaysDate + 'T00:00:00.000Z';
        this.search['date.lessThanOrEqual'] = this.lastDate + 'T23:59:59.009Z';

        this.lookupService.queryDocumentsByDay(this.search).subscribe(
            (res: HttpResponse<DocumentDayDTO[]>) => {
                let temp: DocumentDayDTO[] = [];
                this.isLoading = false;
                this.sentDocumentList = res.body ? res.body : temp;
            },
            (error) => {
                this.isLoading = false;
                if (error.error.status == 400 || error.error.status == 500) {
                    this.sentDocumentList = [];
                }
                // Handle the error here, such as showing a message or performing other actions
            }
        );


    }

    checkboxChanged() {}

    toggleSelection(document: DocumentDayDTO, index: number) {
        //Usage example:
        if (document.selected == true) {
            var file = this.dataUrlToFile(
                `data:image/${document.contentType};base64,${document.imageTag}`,
                `sampleImage_${document.docId}.${document.contentType}`
            );

            let finalObj: SelectedDoc = {
                selectFile: undefined,
                documentObj: undefined,
            };
            const newFileName: string = file!.name?.split('.')[0];
            let docu = {
                id: undefined,
                docType: 'ACTIVITY',
                docStatus: 'Activity',
                fileName: `${newFileName}.${document.contentType}`,
                contentType: document.contentType,
                fileUuid: document.docUuid,
                folderUuid: undefined,
                refTable: 'Activity',
                refTableId: undefined, // This will be set later
                schoolId: this.userData.schoolId,
                status: 'A',
                lastModified: undefined,
                lastModifiedBy: undefined,
                expiryDate: undefined,
            };
            finalObj = {
                selectFile: file,
                documentObj: docu,
            };
            this.selectedDocMap.set(document.docId, finalObj);
        } else {
            if (this.selectedDocMap.has(document.docId)) {
                this.selectedDocMap.delete(document.docId);
            } else {
            }
        }

    }

    selectedImages() {
        this.ref.close(this.selectedDocMap);
    }

    // dataURLtoFile(dataurl:string, filename: string) {
    //     var arr = dataurl.split(','),
    //         mime = arr[0].match(/:(.*?);/)[1],
    //         bstr = atob(arr[arr.length - 1]),
    //         n = bstr.length,
    //         u8arr = new Uint8Array(n);
    //     while(n--){
    //         u8arr[n] = bstr.charCodeAt(n);
    //     }
    //     return new File([u8arr], filename, {type:mime});
    // }

    dataUrlToFile(dataUrl: string, filename: string): File | undefined {
        const arr = dataUrl.split(',');
        if (arr.length < 2) {
            return undefined;
        }
        const mimeArr = arr[0].match(/:(.*?);/);
        if (!mimeArr || mimeArr.length < 2) {
            return undefined;
        }
        const mime = mimeArr[1];
        const buff = Buffer.from(arr[1], 'base64');
        return new File([buff], filename, { type: mime });
    }

    handleDateType(value: string) {
        if (value == 'Daily') {
            const transformedDate: string | null = this.datePipe.transform(
                new Date(),
                'yyyy-MM-dd'
            );
            if (transformedDate !== null) {
                this.handleDateChange(transformedDate);
            } else {
                // Handle the case where transformedDate is null (optional)
                console.error('Transformed date is null');
            }
        }
        if (value == 'Monthly') {
            const currentDate = new Date(); // Get the current date
            const startDateOfMonth = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                1
            );
            this.showMonthlyData(startDateOfMonth.toString());
        }
    }

    handleDateType2(value: string) {
        if (value == 'Daily') {
            const transformedDate: string | null = this.datePipe.transform(
                new Date(),
                'yyyy-MM-dd'
            );
            if (transformedDate !== null) {
                this.handleDateChange2(transformedDate);
            } else {
                // Handle the case where transformedDate is null (optional)
                console.error('Transformed date is null');
            }
        }
        if (value == 'Monthly') {
            const currentDate = new Date(); // Get the current date
            const startDateOfMonth = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                1
            );
            this.showMonthlyData2(startDateOfMonth.toString());
        }
    }

    handleDateChange(newDate: string) {
        this.todaysDate = newDate;
        this.lastDate = newDate;
        this.queryData();
    }

    handleDateChange2(newDate: string) {
        this.todaysDate2 = newDate;
        this.lastDate2 = newDate;
        this.queryData2();
    }

    showMonthlyData(newDate: string) {
        const startDate = new Date(newDate);
        const sDate = this.getStartDateOfMonth(startDate);
        this.todaysDate = this.datePipe.transform(sDate, 'yyyy-MM-dd');
        const lastDateOfMonth = this.getLastDateOfMonth(startDate);
        this.lastDate = this.datePipe.transform(lastDateOfMonth, 'yyyy-MM-dd');
        this.queryData();
    }

    showMonthlyData2(newDate: string) {
        const startDate = new Date(newDate);
        const sDate = this.getStartDateOfMonth(startDate);
        this.todaysDate2 = this.datePipe.transform(sDate, 'yyyy-MM-dd');
        const lastDateOfMonth = this.getLastDateOfMonth(startDate);
        this.lastDate2 = this.datePipe.transform(lastDateOfMonth, 'yyyy-MM-dd');
        this.queryData2();
    }

    getLastDateOfMonth(date: Date): Date {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }

    getStartDateOfMonth(date: Date): Date {
        return new Date(date.getFullYear(), date.getMonth(), 1);
    }

    selectWeek(event: any = new Date()) {
        let selectedDate = new Date(event);
        const currentDate = new Date(); // Current date
        if (!event || isNaN(selectedDate.getTime())) {
            selectedDate = currentDate; // If event is undefined or invalid, default to current date
        }

        const firstDayOfWeek = new Date(selectedDate);
        firstDayOfWeek.setDate(selectedDate.getDate() - selectedDate.getDay());
        const lastDayOfWeek = new Date(firstDayOfWeek);
        lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
        this.selectedDates = [firstDayOfWeek, lastDayOfWeek];
        this.firstDay = this.datePipe.transform(firstDayOfWeek, 'yyyy-MM-dd');
        this.lastDay = this.datePipe.transform(lastDayOfWeek, 'yyyy-MM-dd');
        this.todaysDate = this.firstDay;
        this.lastDate = this.lastDay;
        this.queryData();
    }

    selectWeek2(event: any = new Date()) {
        let selectedDate = new Date(event);
        const currentDate = new Date(); // Current date
        if (!event || isNaN(selectedDate.getTime())) {
            selectedDate = currentDate; // If event is undefined or invalid, default to current date
        }

        const firstDayOfWeek = new Date(selectedDate);
        firstDayOfWeek.setDate(selectedDate.getDate() - selectedDate.getDay());
        const lastDayOfWeek = new Date(firstDayOfWeek);
        lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
        this.selectedDates2 = [firstDayOfWeek, lastDayOfWeek];
        this.firstDay2 = this.datePipe.transform(firstDayOfWeek, 'yyyy-MM-dd');
        this.lastDay2 = this.datePipe.transform(lastDayOfWeek, 'yyyy-MM-dd');
        this.todaysDate2 = this.firstDay2;
        this.lastDate2 = this.lastDay2;
        this.queryData2();
    }

    onReset() {
        this.todaysDate = Common.momentTimeZoneDate(new Date());
        this.lastDate = Common.momentTimeZoneDate(new Date());
        this.selectedbatch = 'Daily';
        this.monthDate = undefined;
        this.selectedDates = undefined;
        this.search = {};
        this.isTrue = false;
        this.queryData();
        this.cdr.detectChanges();
    }
    onReset2() {
        this.todaysDate2 = Common.momentTimeZoneDate(new Date());
        this.lastDate2 = Common.momentTimeZoneDate(new Date());
        this.selectedbatch2 = 'Daily';
        this.monthDate2 = undefined;
        this.selectedDates2 = undefined;
        this.search2 = {};
        this.isTrue = false
        this.queryData2();
    }
}
